module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Вас пригласили присоединиться к аккаунту \\"{companyName}\\"","newPassword":"Новый пароль","newPasswordConfirmation":"Подтвердите новый пароль","join":"Присоединиться","firstName":"Имя","lastName":"Фамилия","phone":"Номер телефона","position":"Должность","logout":"Выйти"}}')
  delete Component.options._Ctor
}
